var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEthereumSolid = function SvgEthereumSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "m12.277 0-.268.912V27.36l.268.267 12.277-7.257z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M12.278 0 0 20.371l12.278 7.258V0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3B",
    d: "m12.277 29.949-.151.184v9.422l.151.441 12.285-17.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M12.278 39.996V29.95L0 22.695z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "m12.277 27.627 12.278-7.257-12.278-5.58z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "m0 20.37 12.278 7.257V14.789z"
  })));
};
export default SvgEthereumSolid;